"use client";

import { Check, AlertCircle } from "lucide-react";
import { formatValue } from "./formatters";
import type { RichResult } from "@/lib/caonabo/rich-content";

type Props = { result: RichResult };

export default function ChatResultCard({ result }: Props) {
  const accent = result.ok ? "#22c55e" : "#ef4444";
  return (
    <div
      className="caonabo-fade-in rounded-xl border overflow-hidden"
      style={{
        background: result.ok ? "rgba(34,197,94,0.06)" : "rgba(239,68,68,0.06)",
        borderColor: result.ok ? "rgba(34,197,94,0.30)" : "rgba(239,68,68,0.30)",
      }}
    >
      <div className="px-3 py-2 flex items-center gap-2">
        <span
          className="inline-flex items-center justify-center rounded-full"
          style={{
            width: 22,
            height: 22,
            background: result.ok
              ? "rgba(34,197,94,0.15)"
              : "rgba(239,68,68,0.15)",
          }}
        >
          {result.ok ? (
            <Check size={12} style={{ color: accent }} />
          ) : (
            <AlertCircle size={12} style={{ color: accent }} />
          )}
        </span>
        <span className="text-[11px] font-bold" style={{ color: accent }}>
          {result.title}
        </span>
      </div>
      {result.summary && (
        <p className="text-[10.5px] text-text-muted px-3 pb-2">{result.summary}</p>
      )}
      {result.fields && result.fields.length > 0 && (
        <div className="px-3 pb-2 grid grid-cols-2 gap-x-2 gap-y-1 text-[10.5px]">
          {result.fields.map((f) => (
            <div key={f.key} className="contents">
              <span className="text-text-muted">{f.label}</span>
              <span className="text-text tabular-nums truncate">{formatValue(f.value)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
